
<template>
  <card>
    <h4 slot="header" class="card-title d-md-flex justify-content-between">
      <span>Şikayetler</span>
    </h4>
    <table class="table table-hover table-striped table-bordered mb-0">
      <caption v-if="!query">Toplam: {{total}}</caption>
      <thead class="thead-dark">
        <th>Yorum</th>
        <th>Şikayetçi</th>
        <th>Sebep</th>
        <th>İşlem</th>
      </thead>
      <tbody>
        <tr v-for="item in table" :key="item.id">
          <td>{{item.comment.comment}}</td>
          <td>{{item.user.username}}</td>
          <td>{{item.reason}}</td>
          <td style="width:15%">
            <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-on:click="deleteComment(item.comment.id)" v-b-tooltip title="Yorumu Kaldır" id="deactivate-item.id"><i class="fas fa-trash fa-fw"></i></a>
            <a href="javascript:void(0)" class="btn btn-xs btn-success btn-fill" v-b-tooltip v-on:click="deleteReport(item.id)" title="Şikayeti Yoksay" id="activate-item.id"><i class="fas fa-times fa-fw"></i></a>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation small" v-if="!query">

      <ul class="pagination justify-content-end">
        <li class="page-item" v-bind:class="{disabled: isFirst()}"><a class="page-link" v-on:click="getPosts(page - 1,type)" >Öncesi</a></li>
        <li class="page-item" v-for="current in pageCount" v-bind:class="{active: isActive(current)}" :key="current"><a href="javascript:void(0)" class="page-link active" v-on:click="getPosts(current,type)">{{current}}</a></li>
        <li class="page-item" v-bind:class="{disabled: isLast()}"><a class="page-link" v-on:click="getPosts(page + 1,type)">Sonrası</a></li>
      </ul>
    </nav>


  </card>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        comment:{
          published:0
        },
        report:{
          is_active:0
        },
        table: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        query:null,
        navigation: true,
        type: 'all',
        viewCounts: []
      }
    },
    components: {
      Card
    },

    methods: {
      changeType: function(t){
        this.type = t
        var buttons = Array.prototype.slice.call(document.getElementsByClassName('type-button'))
        buttons.forEach(function(b){
          b.classList.remove('active')
        })
        event.target.classList.add('active')
        this.getPosts(1,this.type)
      },
      deleteComment: function(id){
        this.toggleLoader()
        this.comment.published = 0
        this.$http.post('/api/comments/edit/' + id, this.comment).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Yorum Yayından Kaldırıldı')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      deleteReport: function(id){
        this.toggleLoader()
        this.report.is_active = 0
        this.$http.post('/api/comment-reports/edit/' + id, this.report).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Şikayet Silindi')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      isActive: function (v) {
        return v === this.page
      },
      isFirst: function () {
        return this.page === 1
      },
      isLast: function () {
        return this.page === Math.ceil(this.total / this.limit)
      },
      getPosts: function (p = 1, t = 'all') {
        this.type = t
        var url = '/api/filter/comment-reports/is-active/1/comments.published/1/limit/' + this.limit + '/page/' + p

        this.$http.get(url).then(
          response => {
            this.table = response.body.data
            this.table.forEach(i=>{
              i.comment.comment = this.$sanitize(i.comment.comment,{allowedTags: ['user-reference']}).replace(/<user-reference>/g,'@').replace(/<\/user-reference>/g, ' ');
            })
            this.total = response.body.meta.total
            this.page = p
            this.pageCount = []
            for (var i = 0; i < this.total / this.limit; i++) {
              this.pageCount.push(i + 1)
            }
          },
          er => {
            this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
          })
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getPosts()
      })
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ReportModules/Index.vue